import { Tag as AntTag } from 'antd'
import type { TagProps } from 'antd'

// Wrapper Tag: bọc AntD Tag để features/pages không import trực tiếp 'antd'
// (hard-rule module-authoring #1). Pass-through, không thêm hành vi.
export default function UiTag(props: TagProps) {
  return <AntTag {...props} />
}
